<script src="https://accounts.google.com/gsi/client" async></script>
<div class="g-signin2" data-onsuccess="onSignIn"></div>
<div *ngIf="!passwordCard && !show2fACard">
    <div class="card-body p-4">
        <div class="text-center mt-2">
            <h5 class="text-primary" i18n="@@">Sign In</h5>
            <p class="text-muted" i18n="@@Login_text_SignIn">PLACEHOLDERTEXT</p>
        </div>
        <div class="p-2 mt-4">
            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                <div class="mb-3">
                    <label class="form-label" for="username" i18n="@@Common_Email">PLACEHOLDERTEXT<span
                            class="text-danger">*</span></label>
                    <input type="email" class="form-control" id="email" formControlName="email"
                        [ngClass]="{ 'is-invalid': submitted && f['email'].errors && (oAuthLogin==false) }"
                        placeholder="Enter email" i18n-placeholder="@@Common_EnterEmail">
                    <div *ngIf="submitted && f['email'].errors && (oAuthLogin==false)" class="invalid-feedback">
                        <div *ngIf="f['email'].errors['required']" i18n="@@Error_EmailRequired">
                            PLACEHOLDERTEXT</div>
                        <div *ngIf="f['email'].errors['pattern']" i18n="@@Error_EmailInvalid">
                            PLACEHOLDERTEXT</div>
                    </div>
                </div>
                <div class="mt-4">
                    <button class="btn btn-success w-100" type="submit" [disabled]="isLoading" i18n="@@">Next</button>
                </div>
            </form>
            <div *ngIf="anyProvidersExist()" class="mt-2 d-flex justify-content-center text-primary  fs-16">
                or
            </div>
            <div class="mt-2 gap-2">
                <button *ngIf="settingsModel.identityProviders!.azureSignIn" class='microsoftButton btn'
                    (click)="msLogin()">
                    <div class="microsoftButtonInner"><img src="assets/images/oauth/msLogo.svg"> Sign In with Microsoft
                    </div>
                </button>
                <button *ngIf="settingsModel.identityProviders!.googleSignIn" class='microsoftButton btn'
                    (click)="oAuthSignInWithLoginProvider(LoginProvider.Google)">
                    <div class="microsoftButtonInner"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="21px"
                            height="21px" viewBox="0 0 48 48" xmlns:xlink="http://www.w3.org/1999/xlink"
                            style="display: block;">
                            <path fill="#EA4335"
                                d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z">
                            </path>
                            <path fill="#4285F4"
                                d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z">
                            </path>
                            <path fill="#FBBC05"
                                d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z">
                            </path>
                            <path fill="#34A853"
                                d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z">
                            </path>
                            <path fill="none" d="M0 0h48v48H0z"></path>
                        </svg> Sign In with Google</div>
                </button>
                <button *ngIf="settingsModel.identityProviders!.facebookSignIn" class='microsoftButton btn'
                    (click)="oAuthSignInWithLoginProvider(LoginProvider.Facebook)">
                    <div class="microsoftButtonInner"><svg id="Layer_1" data-name="Layer 1"
                            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="21px"
                            height="21px" viewBox="0 0 287.56 191">
                            <defs>
                                <style>
                                    .cls-1 {
                                        fill: #0081fb;
                                    }

                                    .cls-2 {
                                        fill: url(#linear-gradient);
                                    }

                                    .cls-3 {
                                        fill: url(#linear-gradient-2);
                                    }
                                </style>
                                <linearGradient id="linear-gradient" x1="62.34" y1="101.45" x2="260.34" y2="91.45"
                                    gradientTransform="matrix(1, 0, 0, -1, 0, 192)" gradientUnits="userSpaceOnUse">
                                    <stop offset="0" stop-color="#0064e1" />
                                    <stop offset="0.4" stop-color="#0064e1" />
                                    <stop offset="0.83" stop-color="#0073ee" />
                                    <stop offset="1" stop-color="#0082fb" />
                                </linearGradient>
                                <linearGradient id="linear-gradient-2" x1="41.42" y1="53" x2="41.42" y2="126"
                                    gradientTransform="matrix(1, 0, 0, -1, 0, 192)" gradientUnits="userSpaceOnUse">
                                    <stop offset="0" stop-color="#0082fb" />
                                    <stop offset="1" stop-color="#0064e0" />
                                </linearGradient>
                            </defs>
                            <title>facebook-meta</title>
                            <path class="cls-1"
                                d="M31.06,126c0,11,2.41,19.41,5.56,24.51A19,19,0,0,0,53.19,160c8.1,0,15.51-2,29.79-21.76,11.44-15.83,24.92-38,34-52l15.36-23.6c10.67-16.39,23-34.61,37.18-47C181.07,5.6,193.54,0,206.09,0c21.07,0,41.14,12.21,56.5,35.11,16.81,25.08,25,56.67,25,89.27,0,19.38-3.82,33.62-10.32,44.87C271,180.13,258.72,191,238.13,191V160c17.63,0,22-16.2,22-34.74,0-26.42-6.16-55.74-19.73-76.69-9.63-14.86-22.11-23.94-35.84-23.94-14.85,0-26.8,11.2-40.23,31.17-7.14,10.61-14.47,23.54-22.7,38.13l-9.06,16c-18.2,32.27-22.81,39.62-31.91,51.75C84.74,183,71.12,191,53.19,191c-21.27,0-34.72-9.21-43-23.09C3.34,156.6,0,141.76,0,124.85Z" />
                            <path class="cls-2"
                                d="M24.49,37.3C38.73,15.35,59.28,0,82.85,0c13.65,0,27.22,4,41.39,15.61,15.5,12.65,32,33.48,52.63,67.81l7.39,12.32c17.84,29.72,28,45,33.93,52.22,7.64,9.26,13,12,19.94,12,17.63,0,22-16.2,22-34.74l27.4-.86c0,19.38-3.82,33.62-10.32,44.87C271,180.13,258.72,191,238.13,191c-12.8,0-24.14-2.78-36.68-14.61-9.64-9.08-20.91-25.21-29.58-39.71L146.08,93.6c-12.94-21.62-24.81-37.74-31.68-45C107,40.71,97.51,31.23,82.35,31.23c-12.27,0-22.69,8.61-31.41,21.78Z" />
                            <path class="cls-3"
                                d="M82.35,31.23c-12.27,0-22.69,8.61-31.41,21.78C38.61,71.62,31.06,99.34,31.06,126c0,11,2.41,19.41,5.56,24.51L10.14,167.91C3.34,156.6,0,141.76,0,124.85,0,94.1,8.44,62.05,24.49,37.3,38.73,15.35,59.28,0,82.85,0Z" />
                        </svg>Sign In with Facebook</div>
                </button>
                <button *ngIf="settingsModel.identityProviders!.appleSignIn" class='microsoftButton btn'
                    (click)="oAuthSignInWithLoginProvider(LoginProvider.Apple)">
                    <div class="microsoftButtonInner"><svg fill="#000000" height="21px" width="21px" version="1.1"
                            id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                            viewBox="0 0 22.773 22.773" xml:space="preserve">
                            <g>
                                <g>
                                    <path d="M15.769,0c0.053,0,0.106,0,0.162,0c0.13,1.606-0.483,2.806-1.228,3.675c-0.731,0.863-1.732,1.7-3.351,1.573
                               c-0.108-1.583,0.506-2.694,1.25-3.561C13.292,0.879,14.557,0.16,15.769,0z" />
                                    <path
                                        d="M20.67,16.716c0,0.016,0,0.03,0,0.045c-0.455,1.378-1.104,2.559-1.896,3.655c-0.723,0.995-1.609,2.334-3.191,2.334
                               c-1.367,0-2.275-0.879-3.676-0.903c-1.482-0.024-2.297,0.735-3.652,0.926c-0.155,0-0.31,0-0.462,0
                               c-0.995-0.144-1.798-0.932-2.383-1.642c-1.725-2.098-3.058-4.808-3.306-8.276c0-0.34,0-0.679,0-1.019
                               c0.105-2.482,1.311-4.5,2.914-5.478c0.846-0.52,2.009-0.963,3.304-0.765c0.555,0.086,1.122,0.276,1.619,0.464
                               c0.471,0.181,1.06,0.502,1.618,0.485c0.378-0.011,0.754-0.208,1.135-0.347c1.116-0.403,2.21-0.865,3.652-0.648
                               c1.733,0.262,2.963,1.032,3.723,2.22c-1.466,0.933-2.625,2.339-2.427,4.74C17.818,14.688,19.086,15.964,20.67,16.716z" />
                                </g>
                            </g>
                        </svg>Sign In with Apple</div>
                </button>

            </div>
        </div>

        <div class="text-center">
            <p class="mb-0" i18n="@@Login_text_NewAccount">PLACEHOLDERTEXT </p>
            <a *ngIf="loginType == LoginType.User" routerLink='/auth/register'
                class="fw-semibold text-primary text-decoration-underline" i18n="@@Link_SignUp">PLACEHOLDERTEXT</a>
            <a *ngIf="loginType == LoginType.Client" routerLink='/auth/client-register'
                class="fw-semibold text-primary text-decoration-underline" i18n="@@Link_SignUp">PLACEHOLDERTEXT</a>
        </div>
    </div>

    <div *ngIf="isLoading" id="elmLoader">
        <div class="spinner-border text-primary avatar-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</div>
<div *ngIf="passwordCard">
    <div class="card-body p-4 ">

        <div class="text-center mb-1 mt-2">
            <h5 class="text-primary" i18n="@@">Welcome!</h5>
            <h6 i18n="@@">{{defaultAuth.email}}</h6>
        </div>
        <div class="text-center mb-3">
            <a href="javascript:void(0);" i18n="@@" (click)="clearData()"><u>Change Account</u></a>
        </div>
        <div class="p-2">
            <div *ngIf="showTenants" class="mb-3" style="justify-content: center;">
                <label for="job_type-field" class="form-label" i18n="@@">
                    Tenant</label>
                <div class="col-12 d-flex inline-flex gap-1">
                    <select class="form-select" [(ngModel)]="defaultAuth.tenantId"
                        [ngClass]="{'is-invalid': (defaultAuth.tenantId == undefined || defaultAuth.tenantId == '' || defaultAuth.tenantId == 'Select Tenant') &&  submitted == true }">
                        <option selected disabled>
                            Select Tenant
                        </option>
                        <option *ngFor="let tenant of tenantSelectOptions" value="{{tenant.tenantId}}">
                            {{tenant.name}}
                        </option>
                    </select>
                </div>
                <div *ngIf='(defaultAuth.tenantId == undefined || defaultAuth.tenantId == "" || defaultAuth.tenantId == "Select Tenant")  &&  submitted == true'
                    style=' margin-top: .25rem; font-size: .875em; color:  #ed5e5e;'>
                    <div i18n="@@">
                        Tenant Required
                    </div>
                </div>
            </div>

            <div *ngIf="!oAuthLogin" class="mb-3">
                <label class="form-label" for="password-input" i18n="@@Common_Password">PLACEHOLDERTEXT<span
                        class="text-danger">*</span></label>
                <div class="position-relative auth-pass-inputgroup">
                    <input class="form-control" [type]="fieldTextType ? 'text' : 'password'"
                        placeholder="Enter Password" i18n-placeholder="@@" [(ngModel)]="defaultAuth.password"
                        [ngClass]="{'is-invalid': stringLengthValidation(defaultAuth.password) == 0  &&  submitted == true }" />
                    <button class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                        type="button" id="password-addon"><i class="mdi align-middle" [ngClass]="{'mdi-eye-off-outline': !fieldTextType, 'mdi-eye-outline': fieldTextType
                  }" (click)="toggleFieldTextType()"></i></button>
                </div>
                <div *ngIf="stringLengthValidation(defaultAuth.password) == 0  &&  submitted == true"
                    style=' margin-top: .25rem; font-size: .875em; color:  #ed5e5e;'>
                    <div i18n="@@">
                        Password Required
                    </div>
                </div>
            </div>
            <!-- <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" id="auth-remember-check">
                <label class="form-check-label" for="auth-remember-check"
                    i18n="@@Login_text_RememberMe">PLACEHOLDERTEXT</label>
            </div> -->
            <div class="mt-4">
                <button class="btn btn-success w-100" (click)="loginWithTenant()" [disabled]="isLoading" i18n="@@">Sign
                    In</button>
            </div>
        </div>
        <div class="text-center mt-4">
            <a *ngIf="loginType == LoginType.User" routerLink="/auth/forgot-password"
                class="fw-semibold text-primary text-decoration-underline"
                i18n="@@Login_text_ForgotPW">PLACEHOLDERTEXT</a>
            <a *ngIf="loginType == LoginType.Client" routerLink="/auth/client-forgot-password"
                class="fw-semibold text-primary text-decoration-underline"
                i18n="@@Login_text_ForgotPW">PLACEHOLDERTEXT</a>
        </div>
    </div>
    <div *ngIf="isLoading" id="elmLoader">
        <div class="spinner-border text-primary avatar-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</div>

<div *ngIf="show2fACard">
    <div class="card-body p-4 ">

          <div class="text-center mb-1 mt-2">
               <h5 class="text-primary" i18n="@@">Two-factor Authentication</h5>
            <h6 i18n="@@">{{defaultAuth.email}}</h6>
        </div>
        <div class="text-center mb-3">
            <a href="javascript:void(0);" i18n="@@" (click)="clearData()"><u>Change Account</u></a>
        </div>

        <div class="p-2">

            <div class="mb-3">
                <label class="form-label" for="password-accessCode">Code</label>
                <div class="position-relative auth-pass-inputgroup">
                    <input class="form-control" type="text" placeholder="Enter the code sent to your email"
                        i18n-placeholder="@@" [(ngModel)]="defaultAuth.accessCode"
                        [ngClass]="{'is-invalid': stringLengthValidation(defaultAuth.accessCode) == 0  &&  submitted == true }" />
                </div>
                <div *ngIf="stringLengthValidation(defaultAuth.accessCode) == 0  &&  submitted == true"
                    style=' margin-top: .25rem; font-size: .875em; color:  #ed5e5e;'>
                    <div i18n="@@">
                        Code Required
                    </div>
                </div>
                <!-- {{timeRemaining(expiry2FADate)}} -->
            </div>
            <div class="mt-4">
                 <button class="btn btn-success w-100 mb-3" (click)="loginWithTenant()" [disabled]="isLoading"
                    i18n="@@">Sign
                    In</button>
                <button class="btn btn-info w-100 mb-3" (click)="resendCode()" [disabled]="isLoading" i18n="@@">Resend
                    Code</button>
               

            </div>

        </div>
    </div>
    <div *ngIf="isLoading" id="elmLoader">
        <div class="spinner-border text-primary avatar-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</div>